import { em } from 'polished'
import styled from 'styled-components'

import { BaseWrapper } from '../styles'

export const Wrapper = styled(BaseWrapper)`
  padding-top: ${em(50)};
`

export const BoxInner = styled.div`
  width: 100%;
`
